import { Button, Heading, Image, Text, VStack } from '@chakra-ui/react';
import { AccountContext } from 'components/AccountContext';
import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CasasBahiaImage from '../../../../images/carrosel/descontos/Banners/CasasBahia.svg';
import ChildHeader from 'components/Dashboard/Main/ChildHeader';

function CasasBahia() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [valor, setValor] = useState([]);
  const { setPage, setUser, user } = useContext(AccountContext);
  const { id_contrato, descricao_plano, titular } = user;
  setPage('Clube de Vantagens');
  return (
    <>
      <ChildHeader />
      <VStack alignItems="left" spacing={2.5} w={'100%'} p={'2em'}>
        <Image src={CasasBahiaImage} borderRadius={20} w="100%" objectFit="cover" />
        <Text textAlign={'justify'} fontSize={'16px'} color={'#474747'} fontWeight={'bold'}>
          O DeoVita te proporciona até 25% de descontos nas suas compras online no site das Casas Bahia.
        </Text>

        <Text textAlign={'justify'} fontSize={'16px'} color={'#474747'} fontWeight={'bold'}>
          O DeoVita te proporciona até 25% de descontos nas suas compras online no site das Casas Bahia.
        </Text>
        <VStack alignItems="left">
          <Button
            bg="#5AB2AE"
            color="#FFFFFF"
            w="100%"
            mt={'2em'}
            onClick={() => {
              window.open('https://www.casasbahia.com.br/', '_blank');
            }}
          >
           Obter meus Descontos
          </Button>
        </VStack>
      </VStack>
    </>
  );
}

export default CasasBahia;
